/**
 * The Weco-Travel logo - Figma component `logo` (`741:4079`).
 *
 * A single vector path: the mark, the wordmark and the "Enriching your travel management"
 * line, 214 x 40 in the file.
 *
 * **It keeps its own colour**, `#222750`, and is deliberately not on the `currentColor`
 * pipeline the icons use. That rule exists so a glyph can take the colour of the text it
 * sits in; a logo is the opposite case - it is the one mark on the page whose colour is
 * not ours to change. A light version for the black footer is a second export from the
 * file, not a CSS filter.
 *
 * Two things were stripped from Figma's export. `preserveAspectRatio="none"` would let
 * the logo squash to whatever box it landed in, and the fixed `width`/`height` would beat
 * the CSS; the `viewBox` carries the proportions instead.
 *
 * The graphic is `aria-hidden` and the accessible name lives on whatever wraps it,
 * because "Weco-Travel" read out twice - once as the link, once as the image - is worse
 * than once.
 */
import logo from './logo-weco-travel.svg?raw';

export function Logo({ className }: { className?: string }) {
  return (
    <span
      aria-hidden
      className={`inline-block [&>svg]:h-full [&>svg]:w-auto ${className ?? ''}`}
      // Build-time constant from a committed file, not user input.
      dangerouslySetInnerHTML={{ __html: logo }}
    />
  );
}
